import React, { FC, useEffect, useState } from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import { Defect, defects, isDefectUsed } from "../../lib/api/defects";
import { TextField } from "../../lib/components/form/TextField";

import { Form } from "react-final-form";

import Button from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import LinearProgress from "@material-ui/core/LinearProgress";
import { CheckboxField } from "../../lib/components/form/CheckboxField";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
    },
    formActions: {
      display: "flex",
      flexDirection: "row",
      gap: "0.5rem",
      justifyContent: "flex-end",
    },
    editingLocked: {
      textAlign: "right",
      fontSize: "16px",
      color: "orange",
      lineHeight: 0,
    },
  });

type DefectsEditFormProps = {
  id: number;
  onClose(): void;
  onSubmit(defect: Defect): void;
} & WithStyles<typeof styles>;

export const DefectsEditFormUnstyled: FC<DefectsEditFormProps> = ({ classes, id, onSubmit, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [defect, setDefect] = useState<Defect | undefined>(undefined);
  const [isEditingLocked, toggleEditingLocked] = useState(true);

  const loadData = async () => {
    setLoading(true);
    try {
      if (id) {
        const result = await defects.single(id);
        const isUsed = await isDefectUsed(result.defect);
        toggleEditingLocked(!!isUsed.length);
        setDefect(result);
      } else {
        toggleEditingLocked(false);
        setLoading(false);
      }
    } catch (error) {
      console.log("🚀 ~ loadData ~ error:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, [id]);

  if (loading) return <LinearProgress />;

  return (
    <div className={classes.root}>
      <Form
        initialValues={defect}
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className={classes.form}>
            <CheckboxField field="active" title="Active" />
            <div>
              <TextField field="defect" title="Defect" required disabled={isEditingLocked} />
              {isEditingLocked && <p className={classes.editingLocked}>Editing locked. Defect is used on Arrivals.</p>}
            </div>
            <div className={classes.formActions}>
              <Button type="button" variant="outlined" color="secondary" onClick={onClose}>
                <CloseIcon />
              </Button>
              <Button type="submit" variant="outlined" color="primary">
                <CheckIcon />
              </Button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default withStyles(styles)(DefectsEditFormUnstyled);
